import * as React from "react";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import no_foto from "assets/images/not_found_image.jpg";
import { PrintContainer } from "components/Printing";

const DetailItem = ({ label, value }) => (
  <MDBox mb={1} width="100%" pr={1}>
    <MDTypography
      variant="caption"
      fontWeight="bold"
      color="text"
      display="block"
      gutterBottom
    >
      {label}
    </MDTypography>
    <MDTypography
      variant="body2"
      fontWeight="regular"
      color="dark"
      sx={{
        display: "block",
        width: "100%",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "normal",
        lineHeight: 1.4,
      }}
    >
      {value || "-"}
    </MDTypography>
  </MDBox>
);

const EstudianteShow = ({ rowData }) => {
  const printRef = React.useRef(null);

  return (
    <PrintContainer
      ref={printRef}
      title={`Expediente - ${rowData.nombre} ${rowData.apellido_paterno}`}
    >
      <MDBox pb={1} position="relative" mt={{ xs: 7, md: 18 }}>
        <MDBox
          component="img"
          src={rowData.foto !== null ? rowData.foto : no_foto}
          alt={rowData.nombre}
          borderRadius="50%"
          shadow="md"
          width="100px"
          height="100px"
          position="absolute"
          left="50%"
          top="-60px"
          sx={{ transform: "translateX(-50%)", zIndex: 1, objectFit: "cover" }}
        />
        <Card sx={{ overflow: "visible" }}>
          <MDBox p={3} pt={6}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <DetailItem label="Nombre (s)" value={rowData.nombre} />
              </Grid>
              <Grid item xs={6}>
                <DetailItem
                  label="Apellido Paterno"
                  value={rowData.apellido_paterno}
                />
              </Grid>
              <Grid item xs={6}>
                <DetailItem
                  label="Apellido Materno"
                  value={rowData.apellido_materno}
                />
              </Grid>

              <Grid item xs={12}>
                <MDBox
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#344767",
                    opacity: 0.2,
                    my: 1,
                  }}
                />
              </Grid>

              <Grid item xs={6} sx={{ lineBreak: "strict" }}>
                <DetailItem label="CURP" value={rowData.curp} />
              </Grid>
              <Grid item xs={6}>
                <DetailItem label="Sexo" value={rowData.genero} />
              </Grid>

              <Grid item xs={6}>
                <DetailItem
                  label="Tipo de sangre"
                  value={rowData.tipo_sangre}
                />
              </Grid>
              <Grid item xs={6}>
                <DetailItem
                  label="Fecha de nacimiento"
                  value={rowData.fecha_nacimiento}
                />
              </Grid>

              <Grid item xs={6}>
                <DetailItem label="Edad" value={`${rowData.edad} años`} />
              </Grid>
              <Grid item xs={6}>
                <DetailItem label="Dirección" value={rowData.direccion} />
              </Grid>

              <Grid item xs={12}>
                <MDBox
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#344767",
                    opacity: 0.2,
                    my: 1,
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <DetailItem
                  label="Matrícula"
                  value={rowData.numero_de_control}
                />
              </Grid>
              <Grid item xs={6}>
                <DetailItem label="Estado" value={rowData.estatus} />
              </Grid>

              <Grid item xs={12}>
                <DetailItem label="Carrera" value={rowData.carrera} />
              </Grid>

              <Grid item xs={12}>
                <MDBox
                  sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#344767",
                    opacity: 0.2,
                    my: 1,
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <DetailItem label="Usuario Wifi" value={rowData.usuario_wifi} />
              </Grid>
              <Grid item xs={6}>
                <DetailItem
                  label="Password Wifi"
                  value={rowData.password_wifi}
                />
              </Grid>

              <Grid item xs={12}>
                <MDBox display="flex" alignItems="center" mb={1}>
                  <Icon fontSize="small" color="info" sx={{ mr: 1 }}>
                    phone
                  </Icon>
                  <MDTypography variant="body2" color="text">
                    {rowData.telefonos?.find((e) => e.tipo === "Móvil")
                      ?.telefono || "-"}
                  </MDTypography>
                </MDBox>
                <MDBox display="flex" alignItems="center">
                  <Icon fontSize="small" color="info" sx={{ mr: 1 }}>
                    email
                  </Icon>
                  <MDTypography variant="body2" color="text">
                    {rowData.email}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
            <MDBox
              className="no-print"
              display="flex"
              justifyContent="center"
              mt={3}
            >
              <MDButton
                variant="gradient"
                color="accent"
                onClick={() => printRef.current?.print()}
              >
                Imprimir
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </PrintContainer>
  );
};

export default EstudianteShow;
